import React from "react";
import IssuePragatiLogo from "./../../assets/pragati-tag.svg";

function AgendaIssuePragatiReview({
  className,
  isPragati,
  isAgendaDetail = false,
  statepmguser
}) {
  return isPragati ? (
    <div
      className={isAgendaDetail ? className : className}
      style={{ marginTop: statepmguser ? "0px" : "-30px" }}
    >
      <img alt="issuePragati" src={IssuePragatiLogo} />
    </div>
  ) : null;
}

export default AgendaIssuePragatiReview;
